import { render, staticRenderFns } from "./AdminSetting.vue?vue&type=template&id=40f8d0e8&scoped=true&"
import script from "./AdminSetting.vue?vue&type=script&lang=ts&"
export * from "./AdminSetting.vue?vue&type=script&lang=ts&"
import style0 from "./AdminSetting.vue?vue&type=style&index=0&id=40f8d0e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f8d0e8",
  null
  
)

export default component.exports